import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from '@mui/material';

interface DeleteConfirmationProps {
  id: number;
  open: boolean;
  onDeleteConfirm: (id: number) => void;
  onCancel: () => void;
  title: string;
  content:string;
}

const DeleteConfirmation: React.FC<DeleteConfirmationProps> = ({ id, open,title,content, onDeleteConfirm, onCancel }) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{content}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">Cancel</Button>
        <Button onClick={() => onDeleteConfirm(id)} color="secondary">Delete</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmation;
